import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgShareLink = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path
      d="M44 36H21C13.268 36 7 42.268 7 50C7 57.732 13.268 64 21 64H44"
      stroke="currentColor"
      strokeWidth="7"
      strokeLinecap="round"
    />
    <path
      d="M55 64L78 64C85.732 64 92 57.732 92 50C92 42.268 85.732 36 78 36L55 36"
      stroke="currentColor"
      strokeWidth="7"
      strokeLinecap="round"
    />
    <rect x="40" y="46" width="19" height="8" rx="4" fill="currentColor" />
  </svg>
);
const ForwardRef = forwardRef(SvgShareLink);
export default ForwardRef;
